import { uploadedDocumentsService } from '../../services';

export const config: any = {
  getUploadedDocuments: () => uploadedDocumentsService.getUploadedDocuments(),
  shareDoc: (params: any) => uploadedDocumentsService.shareDoc(params),
};
